import React from 'react';
import './Partners.scss';

const Partners: React.FC = () => {
  return (
    <div className="partners-view">
      <h3>Partner & Dienstleister</h3>
      <p>Verwaltung externer Partner und Serviceverträge.</p>
    </div>
  );
};

export default Partners;